<template>
  <BlockDrawWinner
    ref="drawWinnerRef"
    :is-disabled="isDisabled"
    @on-draw-winner="execute()"
  />
</template>

<script setup>
const {
    status, data, error, execute,
} = useLazyAsyncData(
    'live-draw',
    () => $fetch('/api/draw/spin', {
        method: 'post',
    }),
    {
        server: false,
        immediate: false,
        transform: (res) => ({
            possibleWinners: res.possible_winners,
            winner: res.winner,
        }),
    },
);

const drawWinnerRef = ref(null);
const isDisabled = ref(false);
watch(() => status.value, (newValue) => {
    if (newValue === 'success') {
        drawWinnerRef.value.initialize(data.value.winner, data.value.possibleWinners);
        drawWinnerRef.value.startSpinning();

        if (data.value.possibleWinners.length === 1) {
            isDisabled.value = true;
        }
    }

    if (newValue === 'error') {
        useSentryError(error.value, {
            useThrow: false,
        });
    }
});
</script>
